import { useState } from 'react'
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'

import type { ReactElement, MouseEvent } from 'react'

import Button from '~/components/Buttons/Button'

import './styles.scss'

interface Props {
  defaultPreview?: string
  previewUrls: string[]
}

const PaginatedPreview = ({ defaultPreview, previewUrls }: Props): ReactElement => {
  const [previewUrlIndex, setPreviewUrlIndex] = useState(0)

  const previewUrl = previewUrls.length > 0 ? previewUrls[previewUrlIndex] : defaultPreview

  const handlePrevious = (evt: MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation()
    setPreviewUrlIndex((index) => {
      if (index > 0) {
        return index - 1
      }
      return previewUrls.length - 1
    })
  }

  const handleNext = (evt: MouseEvent<HTMLButtonElement>) => {
    evt.stopPropagation()
    setPreviewUrlIndex((index) => {
      if (index < previewUrls.length - 1) {
        return index + 1
      }
      return 0
    })
  }

  return (
    <div className="paginated-preview">
      <div className="paginated-preview__text">
        {previewUrlIndex + 1}/{previewUrls.length}
      </div>
      <Button className="paginated-preview__button" ghost onClick={handlePrevious} size="small" type="button">
        <MdKeyboardArrowLeft color="#aeaeae" />
      </Button>
      <img className="paginated-preview__image" src={previewUrl} />
      <Button className="paginated-preview__button" ghost onClick={handleNext} size="small" type="button">
        <MdKeyboardArrowRight color="#aeaeae" />
      </Button>
    </div>
  )
}

export default PaginatedPreview
